import httpService from "./httpService";

const SubjectApi = {
  getSubjectList: (
    phase_id,
    page,
    limit,
    searchData,
    editor_id,
    investigator_id,
    status,
    gender,
    orderBy,
    order,
    userDetails_id = "" // Add user_id parameter with default value
  ) => {

    return httpService.get(
      `subjectList?phase_id=${
        phase_id || ""
      }&page=${page}&limit=${limit}&searchData=${searchData || ""}&editor_id=${
        editor_id || ""
      }&investigator_id=${investigator_id || ""}&status=[${
        status || ""
      }]&gender=${gender || ""}&sort_by=${orderBy || ""}&order_by=${
        order || "desc"
      }${userDetails_id ? `&userDetails_id=${userDetails_id}` : ""}` 
    );
  },
  
  getSubjectDetails: (id) => httpService.get(`subjectDetails/${id}`),
  setAppointmentAnswerData: (data) =>
    httpService.post(`saveAppointmentAnswerData`, data),
  subjectStatusDropDown: () => httpService.get("subjectStatusDropDown"),
  addSubject: (data) => httpService.post("addSubject", data),
  editPatientId: (data) => httpService.post("updatePatientId", data),
  editPatient: (data,id) => httpService.post(`updateSubject/${id}`, data),

  ///////////////////////addAppointment///////////////////
  addAppointment: (data) => httpService.post("addAppointment", data),
  changeLifeStatus: (data) => httpService.post("changeLifeStatus", data),
  addPatientId: (data) => httpService.post("addPatientId", data),
  requestChange:(data)=>httpService.post("add-request-reasons", data),
  getAllRequest: () => httpService.get("list-request-reasons"),

  requestHistory:(limit,page,phase_id,subject_id,filter)=>httpService.post(`get-request-reasons-list?limit=${limit|| '10'}&page=${page|| '1'}&phase_id=${phase_id|| ''}&subject_id=${subject_id ||''}`,filter),
  requestApproval:(payload)=>httpService.put(`resolve-request-reasons-query`,payload),
  exportRequestList:(payload)=>httpService.get(`export-request-reasons-list`,payload),
};
export default SubjectApi;